import React from 'react';

const PrivacyPolicy = () => {
  return (
    <section id="privacy" className="privacy">
      <h2>Privacy Policy</h2>
      <p><strong>Last Updated:</strong> July 2026</p>

      <h3>Introduction</h3>
      <p>
        At Dhriti Solutions Inc., we are committed to protecting your privacy. This policy explains how we collect, use, and safeguard your personal information when you visit our website or use our services.
      </p>

      <h3>Information We Collect</h3>
      <ul>
        <li><strong>You provide:</strong> Name, email, phone, company, job title (via forms or inquiries).</li>
        <li><strong>Automatically:</strong> IP address, browser type, pages visited, and referral source.</li>
        <li><strong>From third parties:</strong> Social media or marketing partners (if applicable).</li>
      </ul>

      <h3>How We Use Your Information</h3>
      <ul>
        <li>To provide services and respond to inquiries.</li>
        <li>To send updates, newsletters, and marketing materials (you may opt out).</li>
        <li>To improve our website and offerings.</li>
        <li>To comply with legal obligations.</li>
      </ul>

      <h3>Sharing Your Information</h3>
      <p>
        We do not sell or rent your data. We may share it with trusted service providers under confidentiality agreements, or as required by law.
      </p>

      <h3>Your Rights</h3>
      <p>
        You may request access, correction, or deletion of your data by contacting us at <a href="mailto:hr@dhriti.solutions">hr@dhriti.solutions</a>.
      </p>

      <h3>Cookies</h3>
      <p>
        We use cookies for analytics and user experience. You can control cookie preferences in your browser settings.
      </p>

      <h3>Contact Us</h3>
      <p>
        Dhriti Solutions Inc.<br />
        20 Sutton Dr, Cohoes, NY 12047<br />
        <strong>Phone:</strong> (971)-998-5516<br />
        <strong>Email:</strong> <a href="mailto:hr@dhriti.solutions">hr@dhriti.solutions</a>
      </p>
    </section>
  );
};

export default PrivacyPolicy;
